import { useState } from "react";
import {
  ResponseGetRemarksTemplateResponse,
  RemarksTemplateApi,
  RemarksTemplateCreateRemarksTemplatePostRequest,
  RequestCreateRemarksTemplateRequest,
} from "../../services/OpenAPI";
import { createConfiguration } from "./common";

export const useApiCreateRemarksTemplate = () => {
  const [remarksTemplateList, setRemarksTemplateList] = useState<
    ResponseGetRemarksTemplateResponse[] | null
  >([]);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const createRemarksTemplate = async (
    req: RequestCreateRemarksTemplateRequest,
  ) => {
    setIsLoading(true);
    setError(null);

    try {
      setIsLoading(true);
      const config = createConfiguration();
      const request: RemarksTemplateCreateRemarksTemplatePostRequest = {
        req,
      };

      const api = new RemarksTemplateApi(config);
      const response =
        await api.remarksTemplateCreateRemarksTemplatePost(request);
      setRemarksTemplateList(response);
      return response;
    } catch (err: any) {
      setError("備考の登録に失敗しました");
      console.error(err);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { createRemarksTemplate, remarksTemplateList, error, isLoading };
};
